<template>
  <nav class="inline-menu" :class="inline_menu_classes">
    <ul class="inline-menu__list">
      <li v-for="menu in menus"
        class="inline-menu__list-item">
        <div class="inline-menu__list-item-block">
          <is-link
            :href="menu.url"
            :is_link="!menu.active"
            @click="scrollPageTop(menu)"
            class="inline-menu__list-item-link"
            :class="{highlighted: location_path_has_career && menu.url.startsWith(jobs_local_url)}">
            <get-menu-title
              :default_title="menu.title"
              :title_array="menu.titles"/>
            <chevron-down-icon v-if="menu.children.length && !hidden_children"/>
          </is-link>
        </div>
        <div
          v-if="menu.children.length && !hidden_children"
          class="inline-menu__list-item__dropdown">
          <ul class="inline-menu__list-item__dropdown-body">
            <li v-for="child_menu in menu.children">
              <is-link
                class="inline-menu__list-item__dropdown-body_link"
                :href="child_menu.url"
                :is_link="!child_menu.active">
                <get-menu-title
                  :default_title="child_menu.show_title || child_menu.title"
                  :title_array="child_menu.titles"/>
              </is-link>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </nav>
</template>

<script>

import IsLink from "../slots/IsLink.vue";
import ChevronDownIcon from "../icons/ChevronDownIcon.vue";
import locale_mixin from "../../mixins/locale_mixin";
import {JOBS_LOCAL_URL, LOCALE_DATA} from "../../helpers/constants";
import GetMenuTitle from "./GetMenuTitle.vue";
import {ssr_document, ssr_window} from "../../helpers/ssr";

export default {
  name: "InlineMenu",
  mixins: [locale_mixin],
  components: {GetMenuTitle, ChevronDownIcon, IsLink},
  props: {
    menus: {
      type: Array,
      default: () => []
    },
    dark_menu: {
      type: Boolean,
      default: false
    },
    hidden_children: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    inline_menu_classes() {
      return {
        dark: this.dark_menu,
        no_dropdown: this.hidden_children
      }
    },
    route_to_home() {
      return this.$context?.route_to_home || false
    },
    main_head_logo_props() {
      if (!this.route_to_home) return {}
      return {
        href: this.route_to_home
      }
    },
    jobs_local_url() {
      return JOBS_LOCAL_URL
    },
    location_path() {
      return ssr_window.location.pathname
    },
    location_path_has_career() {
      return this.location_path.startsWith(this.jobs_local_url)
    }
  },
  methods: {
    scrollPageTop({active}) {
      if (!active) return
      ssr_document?.body?.scrollIntoView()
    }
  }
}
</script>
